module.exports = __webpack_public_path__ + "static/media/due-port11.af92912a.jpg";